import Box from "../../../../components/Box";
import { useDispatch } from "react-redux";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomDateTimePicker from "../../../../components/CustomDateTimePicker";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { ServiceService } from "../../../../services/ServiceService";
import { CompanyPoService } from "../../../../services/CompanyPoService";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { GetCompanyPoListResponse } from "../../../../models/response/companyPo/GetCompanyPoListResponse";
import { CarryTypeEnum } from "../../../../models/common/Enums";
import MailListesiAlani from "../../../../components/MailListesiAlani";

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCustomer: CustomSingleSelectModel | undefined
    setSelectedCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCarryType: CustomSingleSelectModel | undefined
    setSelectedCarryType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCarryMethod: CustomSingleSelectModel | undefined
    setSelectedCarryMethod: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    warehouseReceipt: string | undefined
    setWarehouseReceipt: React.Dispatch<React.SetStateAction<string | undefined>>
    customerDeliveryNoteNumber: string | undefined
    setCustomerDeliveryNoteNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedExpressVehicle: CustomSingleSelectModel | undefined
    setSelectedExpressVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDivision: CustomSingleSelectModel | undefined
    setSelectedDivision: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedPo: CustomSingleSelectModel | undefined
    setSelectedPo: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    poNo: string | undefined
    setPoNo: React.Dispatch<React.SetStateAction<string | undefined>>
    note: string | undefined
    setNote: React.Dispatch<React.SetStateAction<string | undefined>>
    /** Teslimde bilgilendirme maili gidecek adresler ("a@x.com, b@y.net"). */
    bilgilendirmeMailleri: string | undefined
    setBilgilendirmeMailleri: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedOrderStatus: CustomSingleSelectModel | undefined
    setSelectedOrderStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    orderDate: string | undefined
    /** Aylık sabit gelir siparişi (08.10.2026): yalnız Müşteri, Sipariş Tarihi, Bölüm, PO, PO Numarası ve Not görünür. */
    sabitGelir?: boolean
    setOrderDate?: (_value: string | undefined) => void
    /** Başlığın yanında gösterilecek ek bilgi (aylık sabit gelir rozetleri ve "Satırları yenile"). */
    baslikEki?: React.ReactNode
}

const GeneralInformation = ({
    generalInformationRef,
    refNo,
    setRefNo,
    selectedCustomer,
    setSelectedCustomer,
    selectedCarryType,
    setSelectedCarryType,
    selectedCarryMethod,
    setSelectedCarryMethod,
    warehouseReceipt,
    setWarehouseReceipt,
    customerDeliveryNoteNumber,
    setCustomerDeliveryNoteNumber,
    selectedDivision,
    selectedExpressVehicle,
    selectedPo,
    setSelectedDivision,
    setSelectedExpressVehicle,
    setSelectedPo,
    note,
    poNo,
    setNote,
    setPoNo,
    bilgilendirmeMailleri,
    setBilgilendirmeMailleri,
    selectedOrderStatus,
    setSelectedOrderStatus,
    orderDate,
    sabitGelir,
    setOrderDate,
    baslikEki,
}: Props) => {
    const dispatch = useDispatch();

    const onDivisionChange = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            setSelectedDivision(_selectedValue);

            if (_selectedValue) {
                dispatch(storeActivityIndicator(true));

                var response2: GetCompanyPoListResponse = await CompanyPoService.getCompanyPoList(orderDate, selectedCustomer, _selectedValue)

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                if (response2.data.length > 0) {
                    setSelectedPo({ label: response2.data[0].poName, value: response2.data[0].poId });
                    setPoNo(response2.data[0].poNo);
                    return;
                }
            }

            setSelectedPo(undefined);
            setPoNo(undefined);
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <div className='containerPart' ref={generalInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <Box className="mb-10" flexDirection="row" alignItems="center">
                        <Box justifyContent="center">
                            <h4 className="text-black m-0">Genel Bilgiler</h4>
                        </Box>
                        {
                        refNo && (
                            <Box justifyContent="center" ml="12px">
                                <span className="badge badge-light-primary fs-8 fw-semibold py-2 px-3">
                                    <span className="text-gray-600 me-2">Ref No</span>{refNo}
                                </span>
                            </Box>
                        )
                    }
                    {baslikEki}
                    </Box>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Müşteri'
                                isLabelRequired
                                selectedValue={selectedCustomer}
                                onChange={(value) => {
                                    setSelectedCustomer(value);
                                    onDivisionChange(undefined);
                                }}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isCustomer: true })
                                ]}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>

                        {
                            sabitGelir && (
                                <div className="col-md-4">
                                    <CustomDateTimePicker labelText="Sipariş Tarihi" isLabelRequired value={orderDate} setValue={(v: string | undefined) => setOrderDate?.(v)} />
                                </div>
                            )
                        }

                        {!sabitGelir && (<>
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Taşıma Yöntemi"
                                isLabelRequired
                                selectedValue={selectedCarryType}
                                onChange={setSelectedCarryType}
                                onMenuOpen={() => ConstantService.getConstantList('CARRY_TYPE')}
                                labelName='value'
                                valueName='constantId'
                                additionalValue1Name="additionalValue1"
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Sipariş Durumu"
                                isLabelRequired
                                selectedValue={selectedOrderStatus}
                                onChange={setSelectedOrderStatus}
                                onMenuOpen={() => ConstantService.getConstantList('ORDER_STATUS_AMBAR')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>
                        </>)}
                    </div>

                    {!sabitGelir && (
                    <div className='row mt-5'>
                        <div className="col-md-4">
                            <CustomTextInput labelText="Taşıma İrsaliyesi" value={warehouseReceipt} setValue={setWarehouseReceipt} />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="Müşteri İrsaliye No" value={customerDeliveryNoteNumber} setValue={setCustomerDeliveryNoteNumber} />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Taşıma Tipi"
                                selectedValue={selectedCarryMethod}
                                onChange={setSelectedCarryMethod}
                                onMenuOpen={() => ConstantService.getConstantList('CARRY_METHOD')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        {/* <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Ekspres Araç"
                                selectedValue={selectedExpressVehicle}
                                onChange={setSelectedExpressVehicle}
                                onMenuOpen={() => ConstantService.getConstantList('EXPRESS_VEHICLE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div> */}
                    </div>
                    )}

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Bölüm</label>

                            <CustomSingleSelect
                                selectedValue={selectedDivision}
                                onChange={onDivisionChange}
                                onMenuOpen={selectedCustomer ? () => CompanyPoService.getCompanyPoList(undefined, selectedCustomer, undefined) : undefined}
                                labelName='divisionName'
                                valueName="divisionId"
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">PO</label>

                            <CustomSingleSelect
                                selectedValue={selectedPo}
                                onChange={setSelectedPo}
                                onMenuOpen={() => ServiceService.getServiceList(true)}
                                labelName='name'
                                valueName='serviceId'
                                additionalValue1Name='incomePercentageName'
                                disabled={!selectedDivision}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="PO Numarası" value={poNo} setValue={setPoNo} isDisabled={!selectedDivision} />
                        </div>
                    </div>

                    {/* Bekleme Süresi ve üç anahtar "Operasyonel Bilgiler" grubuna taşındı. */}

                    {/* Not ilk iki sütun (Bölüm + PO) genişliğinde; üçüncü sütunda (PO Numarası'nın altında) Bilgilendirme Mailleri. */}
                    <div className="row mt-5">
                        <div className="col-md-8">
                            <label className="form-label">Not</label>
                            <textarea rows={3} value={note ?? ''} onChange={(e) => setNote(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', resize: 'vertical' }} className="form-control form-control-solid" />
                        </div>

                        <div className="col-md-4">
                            <MailListesiAlani labelText="Bilgilendirme Mailleri" rows={3} value={bilgilendirmeMailleri} setValue={setBilgilendirmeMailleri} />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;